import { Button } from '../../components/Button';
import { Checkbox } from '../../components/Checkbox';
import { ExpandableSection } from '../../components/ExpandableSection';
import { FormCard } from '../../components/FormCard';
import { FormField } from '../../components/FormField';
import { TextInput } from '../../components/FormField/FormField.styles';
import { SectionHeader } from '../../components/SectionHeader';
import { TextArea } from '../../components/TextArea';
import {
  ButtonGroup,
  CategoriesSection,
  FreeTextWrapper,
  HeaderRow,
  OtherInputWrapper,
  Panel,
} from './PreferencesPanel.styles';
import type { PreferencesPanelProps } from './PreferencesPanel.types';

export function PreferencesPanel({
  title = 'Add any preferences?',
  enabled,
  onToggle,
  categories,
  onCategoryToggle,
  onOptionToggle,
  onOtherChange,
  onFreeTextChange,
  expandedCategories,
  otherButtonLabel = 'Other',
}: PreferencesPanelProps) {
  return (
    <Panel>
      <HeaderRow>
        <SectionHeader title={title} />
        <Checkbox checked={enabled} onChange={onToggle} />
      </HeaderRow>

      {enabled && (
        <CategoriesSection>
          {categories.map((category) => {
            const isExpanded = expandedCategories.includes(category.id);
            const isOtherSelected = category.selectedOptions?.includes(otherButtonLabel);

            if (category.isFreeText || !category.options || category.options.length === 0) {
              return (
                <ExpandableSection
                  key={category.id}
                  label={category.label}
                  expanded={isExpanded}
                  onToggle={(val) => onCategoryToggle(category.id, val)}
                  hideCheckbox
                >
                  <FreeTextWrapper>
                    <FormCard>
                      <FormField label={category.otherLabel || category.label}>
                        <TextArea
                          placeholder={category.freeTextPlaceholder}
                          value={category.freeTextValue || ''}
                          onChange={(e) => onFreeTextChange(category.id, e.target.value)}
                        />
                      </FormField>
                    </FormCard>
                  </FreeTextWrapper>
                </ExpandableSection>
              );
            }

            return (
              <ExpandableSection
                key={category.id}
                label={category.label}
                expanded={isExpanded}
                onToggle={(val) => onCategoryToggle(category.id, val)}
              >
                {category.options && (
                  <ButtonGroup>
                    {category.options.map((option) => (
                      <Button
                        key={option}
                        variant="toggle"
                        size="small"
                        selected={category.selectedOptions?.includes(option)}
                        onClick={() => onOptionToggle(category.id, option)}
                        type="button"
                      >
                        {option}
                      </Button>
                    ))}
                    {!category.options.includes(otherButtonLabel) && (
                      <Button
                        variant="toggle"
                        size="small"
                        selected={isOtherSelected}
                        onClick={() => onOptionToggle(category.id, otherButtonLabel)}
                        type="button"
                      >
                        {otherButtonLabel}
                      </Button>
                    )}
                  </ButtonGroup>
                )}
                {isOtherSelected && (
                  <OtherInputWrapper>
                    <FormCard>
                      <FormField label={category.otherLabel || category.label}>
                        <TextInput
                          value={category.otherValue || ''}
                          onChange={(e) => onOtherChange(category.id, e.target.value)}
                        />
                      </FormField>
                    </FormCard>
                  </OtherInputWrapper>
                )}
              </ExpandableSection>
            );
          })}
        </CategoriesSection>
      )}
    </Panel>
  );
}
